(() => {
	const desktopMedia = window.matchMedia('(min-width: 1200px)');
	let observer;
	let contentObserver;
	let observedSelector;

	const getTarget = () => {
		if (desktopMedia.matches) {
			return document.getElementById('custom__md-footer-selector-block');
		}

		return document.querySelector('[data-orbe-mobile-target]');
	};

	const getReturnsTarget = () => desktopMedia.matches
		? document.querySelector('.announcement-bar__utility-localization')
		: document.querySelector('.header-mobile__localization-wrapper--orbe');

	const moveReturnsLink = () => {
		const link = document.querySelector('[data-header-returns]');
		const target = getReturnsTarget();
		if (!link || !target) return;

		if (desktopMedia.matches) {
			const selectorTarget = document.getElementById('custom__md-footer-selector-block');
			if (link.parentElement !== target || link.nextElementSibling !== selectorTarget) {
				target.insertBefore(link, selectorTarget);
			}
		} else if (link.parentElement !== target) {
			target.appendChild(link);
		}
	};

	const localizeCountryNames = (selector) => {
		const labels = document.querySelector('[data-orbe-country-labels]');
		if (!labels) {
			return;
		}

		const languageLabel = labels.getAttribute('data-language-label');
		selector.querySelectorAll('[data-mdapplanguagelabel]').forEach((label) => {
			if (languageLabel && label.textContent !== languageLabel) label.textContent = languageLabel;
		});
		const getLabel = (countryCode) => labels.getAttribute(`data-${countryCode?.toLowerCase()}`);
		const countryButton = selector.querySelector('#md-form__select__country--footer');
		const selectedLabel = getLabel(countryButton?.dataset.value);
		const selectedText = countryButton?.querySelector('.md-form__select__span');

		if (selectedLabel && selectedText) {
			if (selectedText.textContent !== selectedLabel) {
				selectedText.textContent = selectedLabel;
			}
			if (countryButton.getAttribute('aria-label') !== selectedLabel) {
				countryButton.setAttribute('aria-label', selectedLabel);
			}
		}

		selector.querySelectorAll('.md-form__select__country__list li[data-country]').forEach((option) => {
			const label = getLabel(option.dataset.country);
			const text = option.querySelector('.md-form__select__span');

			if (label && text && text.textContent !== label) {
				text.textContent = label;
			}
		});
	};

	const watchSelectorContent = (selector) => {
		if (observedSelector === selector) {
			return;
		}

		contentObserver?.disconnect();
		observedSelector = selector;
		contentObserver = new MutationObserver(() => localizeCountryNames(selector));
		contentObserver.observe(selector, {
			childList: true,
			subtree: true,
			characterData: true,
			attributes: true,
			attributeFilter: ['data-value']
		});
	};

	const moveSelector = () => {
		moveReturnsLink();
		const selector = document.getElementById('md-footer-selector-block');
		const target = getTarget();

		if (!selector || !target) {
			return false;
		}

		if (selector.parentElement !== target) {
			target.appendChild(selector);
		}
		localizeCountryNames(selector);
		watchSelectorContent(selector);

		return true;
	};

	const watchForSelector = () => {
		moveSelector();

		if (observer) {
			return;
		}

		observer = new MutationObserver(() => {
			moveReturnsLink();
			const selector = document.getElementById('md-footer-selector-block');
			const target = getTarget();
			if (selector && target && (selector !== observedSelector || selector.parentElement !== target)) {
				moveSelector();
			}
		});

		observer.observe(document.documentElement, { childList: true, subtree: true });
	};

	if (desktopMedia.addEventListener) {
		desktopMedia.addEventListener('change', watchForSelector);
	} else {
		desktopMedia.addListener(watchForSelector);
	}

	document.addEventListener('shopify:section:load', watchForSelector);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', watchForSelector, { once: true });
	} else {
		watchForSelector();
	}
})();

